export default "__VITE_ASSET__B8yJs6QD__"